module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("5")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("W")]), _vm._v("hen the call ended, Graciella Miramar checked the charge on her encrypted phone. It was low. After switching it off, she hooked it up to one of the charging cables in the small, specially designed safe concealed under the hardwood flooring in her bedroom closet. “Come home to Sinaloa,” she muttered under her breath. “Not bloody likely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That may have been her father’s plan, but it wasn’t hers. For one thing, Graciella had never even "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("been")]), _vm._v(" to Sinaloa. El Pescado’s armed compound certainly wasn’t home to her, and she had no intention of living there in what would amount to little more than a glorified prison. However, just because she refused to live in Sinaloa didn’t mean Graciella had no interest in taking over the Duarte Cartel.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("In her estimation, the use of human mules to lug backpacks loaded with illicit product back and forth across international borders was a business model that needed to be relegated to the history books. Graciella wanted to be in charge of something far more elegant than that. When El Pescado’s gang came under fire, as it inevitably would, Graciella had absolutely no interest in being gunned down by automatic weapons fire in some kind of Wild West shootout with either the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("federales")]), _vm._v(" or else members of some rival ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("gang. That kind of an ending might be suitable for her half brothers, but not for her.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Long term, Graciella wanted to be out of the drug business entirely but with her own money and that of her father’s collapsed drug cartel still intact. In order to do that, she would need a suitable partner, and she already had one in mind. For the past week, while home on bereavement leave, she’d worked feverishly to that end, and bit by bit the pieces were falling into place. If everything worked out the way she hoped, Graciella’s new partner would be an artificial intelligence named Frigg. The AI had once belonged to a client of hers who was now deceased.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the moment Graciella wasn’t even sure Frigg still existed. If she did, she was most likely in the care and custody of a guy named Stuart Ramey who lived in Cottonwood, Arizona. Graciella had already embarked on the mission to find out for sure because, if Frigg was still extant, Graciella was determined to make Owen Hansen’s AI her own—with or without Stuart Ramey’s help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yesterday had been Graciella’s last full day of bereavement leave. Today she was due in at the office. And by this afternoon, the surveillance feeds she had ordered would be up and running in both Stuart Ramey’s residence and at his place of work. When she knew for sure that Frigg was operative again, Graciella would determine her next move.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once dressed, Graciella called the office. Naturally, her boss answered the phone. Just hearing Arturo Salazar’s voice was enough to make her skin crawl. “I’m on my way in,” she told him, “but I’m going to be a few minutes late. I have to make arrangements to ship my mother’s ashes home to her family.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you need to take another day off, do so,” Arturo told her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s very kind of you,” she said, “but really. I’m ready to be back at work. Being home here without her is just too hard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course,” Arturo said. “I understand.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Out in the living room the funeral urn still sat next to the front door in exactly the same place where the driver from the mortuary had placed it when he delivered Christina Miramar’s cremains. When the man from the funeral home had called late the previous afternoon to say that the ashes were already en route, Graciella had wanted to tell him to go ahead and keep them, but she had realized just in time that a reaction like that would most likely arouse suspicion and get people started asking too many uncomfortable questions.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Once the urn arrived, Graciella wasn’t sure what she should do with it. Put it on display somewhere in the living room and tell anyone who asked that she was honoring her mother’s wishes, or hide it in the back corner of a closet? Now, though, she was grateful that El Pescado’s unexpected request had solved the problem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bending over to pick up the urn, she was surprised by how much it weighed, but she shouldered the burden with a happy heart. The shipping office was just up the street. She wouldn’t have to carry it far.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9be30a28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 84
// module chunks = 0